'use strict'
import Vue from 'vue'
import vueResource from 'vue-resource'

Vue.use(vueResource)

Vue.http.interceptors.push((request, next) => {
  if (!!localStorage.token) {
  
    request.headers.set('Authorization', localStorage.token)
  }
  next()
})

export default {
  data() {

  },
  methods: {
    cacl(value){
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth
          if (deviceWidth >= 750) {
          deviceWidth = 750
          }
          if (deviceWidth <= 320) {
          deviceWidth = 320
          }

      return 10/(deviceWidth/value)
    },
    login(url, params, callback) {
      this.$http.post(url, params).then((response) => {
        callback(response.body)
      }, (response) => {

      })
    },
   fetchData(url, params, callback) {
    
      this.$http.get(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          callback(response.body.data,response)
       
        }
      }, (response) => {
        console.error(response)
      })
    },
    requestData(url){
     return this.$http.get(url)

    },

    fetchDataErp(url, params, callback) {
      
      this.$http.get(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          callback(response.body,response)
        }
      }, (response) => {
        console.error(response)
      })
    },

    subForm(url, params, callback) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        fullscreen:true,
        background: 'rgba(0, 0, 0, 0.5)'
      });
      this.$http.post(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          loading.close();
          callback(response.body)
          
        }
      }, (response) => {
        console.error(response)
        this.$message.error(response.body.message)
      })
    },
    patchData(url, params, callback) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   fullscreen:true,
      //   background: 'rgba(0, 0, 0, 0.5)'
      // });
      this.$http.patch(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          // loading.close();
          callback(response.body)
          
        }
      }, (response) => {
        console.error(response)
        this.$message.error(response.body.message)
      })
    },
    deleteData(url, params, callback) {
      this.$http.delete(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          callback(response.body)
        }
      }, (response) => {
        console.error(response)
      })
    },
    putData(url, params, callback) {
      this.$http.put(url, params).then((response) => {
        if (response.body.code == '0001') {
          this.$router.push({ name: 'login' })
          this.$message.warning('请重新登录')
        } else {
          callback(response.body)
        }
      }, (response) => {
        console.error(response)
      })
    },

    getUser(url){
      let userList = []
      this.fetchData(url+'?size=999','',(data)=>{
          userList = data.content
      })
      return userList
  },

  }
}



// WEBPACK FOOTER //
// ./src/util/ajax.js